import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import authToken from 'src/utils/auth';
import requestHeaders, { requestFullHeaders } from './headers';
import refreshTokens from './refreshTokens';

export const logoutLink = onError(
  ({ networkError, graphQLErrors, operation, forward }) => {
    const hasNetworkError = networkError && networkError.status;
    const hasUnauthError =
      graphQLErrors &&
      graphQLErrors[0] &&
      (graphQLErrors[0].extensions.code === 401 || graphQLErrors[0].extensions.code === 'UNAUTHENTICATED') &&
      graphQLErrors[0].path?.[0] !== 'updateTokens';
    if (hasNetworkError) {
      authToken(null);
    }
    // uncomment below code when refresh token in auth0 is implemented
    // if (hasUnauthError) {
    //   return refreshTokens(operation, forward);
    // }
  },
);

export const authLink = setContext((request, { headers }) => {
  if (['updateTokens', 'signOut'].includes(request.operationName)) {
    return {
      headers: {
        ...headers,
        ...requestFullHeaders(),
      },
    };
  }
  return {
    headers: {
      ...headers,
      ...requestHeaders(),
    },
  };
});
